import { httpRequest } from '@/utils/umiRequest';

export interface AliOSSProps {
  AccessKeyId: string;
  AccessKeySecret: string;
  Bucket: string;
  Expiration: string;
  Region: string;
  SecurityToken: string;
  Domain: string;
}

export const OSS_ACCESS_URL = 'https://qdesk-im-test-apps.oss-cn-shenzhen.aliyuncs.com';

// 获取阿里云oss令牌
export const fetchAliOSS = async () => await httpRequest.get<AliOSSProps>('/config-oss/IM');
